export default{
ConfigReducer:{
configs:{},
stores:[],
eventManagers:[],
brandContacts:[]},

EventDetailReducer:{
eventDetail:{},
eventId:null}};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9yZWR1Y2Vycy9pbml0aWFsU3RhdGUuanMiXSwibmFtZXMiOlsiQ29uZmlnUmVkdWNlciIsImNvbmZpZ3MiLCJzdG9yZXMiLCJldmVudE1hbmFnZXJzIiwiYnJhbmRDb250YWN0cyIsIkV2ZW50RGV0YWlsUmVkdWNlciIsImV2ZW50RGV0YWlsIiwiZXZlbnRJZCJdLCJtYXBwaW5ncyI6IkFBQUEsY0FBZTtBQUNiQSxjQUFlO0FBQ2JDLFFBQVMsRUFESTtBQUViQyxPQUFRLEVBRks7QUFHYkMsY0FBZSxFQUhGO0FBSWJDLGNBQWUsRUFKRixDQURGOztBQU9iQyxtQkFBb0I7QUFDbEJDLFlBQWEsRUFESztBQUVsQkMsUUFBUyxJQUZTLENBUFAsQ0FBZiIsImZpbGUiOiJpbml0aWFsU3RhdGUuanMiLCJzb3VyY2VSb290IjoiL2FwcCIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IHtcbiAgQ29uZmlnUmVkdWNlcjoge1xuICAgIGNvbmZpZ3M6IHt9LFxuICAgIHN0b3JlczogW10sXG4gICAgZXZlbnRNYW5hZ2VyczogW10sXG4gICAgYnJhbmRDb250YWN0czogW10sXG4gIH0sXG4gIEV2ZW50RGV0YWlsUmVkdWNlcjoge1xuICAgIGV2ZW50RGV0YWlsOiB7fSxcbiAgICBldmVudElkOiBudWxsLFxuICB9LFxufTtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./src/reducers/initialState.js
// module id = 762
// module chunks = 0